export const USER_ROLE = {
  ADMIN_SUPER: "admin-super",
  ADMIN_ORG: "admin-organization",
  ADMIN_WORKSPACE: "admin-group",
  PUBLISHER: "publisher",
  VIEWER: "viewer",
};
